import React from 'react';
import Parser from 'html-react-parser';
import {withScriptjs, withGoogleMap, GoogleMap, Marker} from "react-google-maps";
import Modal from 'react-responsive-modal';

import './Footer.scss';

class Footer extends React.Component {

  constructor() {
    super();

    this.state = {
      branchActive: 1,
      open: false
    }
  }

  onOpenModal = () => {
    this.setState({open: true});
  };

  onCloseModal = () => {
    this.setState({open: false});
  };

  changeActiveTab = (e) => {
    e.preventDefault();

    this.setState({
      branchActive: parseInt(e.target.id)
    })
  };

  filterBranchesByType = (type) => {
    return this.props.branches.cities.filter(branch => branch.type === type);
  };

  renderMenuItems = (type) => {
    const branches = this.filterBranchesByType(type);
    return branches.map((branch) => {
      const activeClass = branch.id === this.state.branchActive ? "active" : "";
      return (
        <a
          key={branch.id}
          id={branch.id}
          className={`footer_tablist_title ${activeClass}`}
          onClick={this.changeActiveTab}
        >{branch.name}</a>
      )
    });
  };

  renderBranch = () => {
    const branch = this.props.branches.cities.find(branch => branch.id === this.state.branchActive);
    const main = this.props.langs.main;

    const { open } = this.state;

    return (
      <div className="row">
        <div className="col-8 footer_placeInfo">
          <ul className="footer_ul">
            <li><i className="llc-placeholder"/> {branch.street}</li>
            <li>{`${branch.zip} ${branch.city}`}</li>
            {branch.tel && <li><i className="llc-phone-call"/> <strong>Tel.:</strong> {branch.tel}</li>}
            {branch.mobile && <li><i className="llc-smartphone"/> <strong>Mobil:</strong> {branch.mobile}</li>}
            {branch.fax && <li><i className="llc-fax"/> <strong>Fax :</strong> {branch.fax}</li>}
            {branch.email &&
            <li>
              <i className="llc-arroba"/>
              <strong>E-mail :</strong> <a href={`mailto:${branch.email}`}>{branch.email}</a>
            </li>
            }
            {branch.video &&
            <li className="cursor-pointer td-underline">
              <a role="button" onClick={this.onOpenModal}>
                <i className="llc-video-camera"/>
                Prohlédněte si naši pobočku
              </a>
              <Modal classNames={{modal:'footer_video',closeButton:'footer_video_close'}} open={open} onClose={this.onCloseModal}>
                <iframe width="854"
                        height="480"
                        src={"https://www.youtube.com/embed/" + branch.video}
                        frameBorder="0"
                        allowFullScreen
                />
              </Modal>
            </li>
            }
          </ul>
        </div>


        {/*
        {branch.opening_holidays &&
        <div className="col-4 footer_openTime">
          <div className="clearfix">
            <div className="pull-right">
              <div className="footer_openTime_title">{main.opening_hours_holidays}:</div>
              <ul>
                <li><span>{main.days.mo}:</span> {branch.opening_holidays.mo}</li>
                <li><span>{main.days.tu}:</span> {branch.opening_holidays.tu}</li>
                <li><span>{main.days.we}:</span> {branch.opening_holidays.we}</li>
                <li><span>{main.days.th}:</span> {branch.opening_holidays.th}</li>
                <li><span>{main.days.fr}:</span> {branch.opening_holidays.fr}</li>
              </ul>
            </div>
          </div>
        </div>
        }
        */}
        {branch.opening &&
        <div className="col-4 footer_openTime">
          <div className="clearfix">
            <div className="pull-right">
              <div className="footer_openTime_title">{main.opening_hours}:</div>
              <ul>
                <li><span>{main.days.mo}:</span> {branch.opening.mo}</li>
                <li><span>{main.days.tu}:</span> {branch.opening.tu}</li>
                <li><span>{main.days.we}:</span> {branch.opening.we}</li>
                <li><span>{main.days.th}:</span> {branch.opening.th}</li>
                <li><span>{main.days.fr}:</span> {branch.opening.fr}</li>
              </ul>
            </div>
          </div>
        </div>
        }
        {branch.openingAlt &&
        <div className="col-4 footer_openTime">
          <div className="clearfix">
            <div className="pull-right">
              <div className="footer_openTime_title">{main.opening_hours}:</div>
              <ul>
                <li className="text-right">{branch.openingAlt}</li>
              </ul>
            </div>
          </div>
        </div>
        }
      </div>
    )
  };

  renderMap = () => {
    const branch = this.props.branches.cities.find(branch => branch.id === this.state.branchActive);
    let MapWithAMarker = withScriptjs(withGoogleMap(props =>
      <GoogleMap
        defaultZoom={17}
        defaultCenter={{lat: branch.mapLat, lng: branch.mapLng}}
      >
        <Marker
          position={{lat: branch.mapLat, lng: branch.mapLng}}
        />
      </GoogleMap>
    ));

    /*
    return (
      <MapWithAMarker
        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCOJm_YcTsXilBF1IWQQtbA7dy-U5F7yqs&v=3.exp&libraries=geometry,drawing,places"
        loadingElement={<div style={{height: `100%`}}/>}
        containerElement={<div style={{height: `255px`}}/>}
        mapElement={<div style={{height: `100%`}}/>}
      />
    )
    */

    return( branch.mapIframe )
  };

  render() {
    const footer = this.props.langs.footer;

    return (
      <footer className="footer no-print">
        <div className="container">
          <div className="row">
            <div className="col-7 footer_left">
              <h3><i className="llc-heartbeat"/>{Parser(footer.title_left)} :</h3>
              <div className="footer_tablist">
                {this.renderMenuItems(1)}
              </div>
              {this.renderBranch()}
            </div>
            <div className="col-5 footer_right">
              <h3><i className="llc-chat"/>{footer.title_right} :</h3>
              <div className="footer_tablist">
                {this.renderMenuItems(2)}
              </div>
              <div className="footer_map">
                {this.renderMap()}
              </div>
            </div>
          </div>

          <div className="footer_createdBy">
            Created by <a target="_blank" href="http://webble.cz/">Webble.cz</a>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Layout/Footer/Footer.js